import React from "react";
import "../styles.css"; // Custom styles for the app

export const ActionButtonFull = ({ title }) => {
  return (
    <div className="cta-button-full">
      <div className="cta-button-full-content">{title}</div>
    </div>
  );
};

export const ActionButton = ({ title }) => {
  return (
    <div className="cta-button">
      <div className="cta-button-content">{title}</div>
    </div>
  );
};
